import ForeclosureItem from './ForeclosureItem';
import { formatAmount } from '@cp/src/utils/commonUtils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';
import { CircularLoaderIcon, InfoIcon } from '@navi/web-ui/lib/icons';
import { Typography } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';
import { IForeclosureDetails } from './interface';

const ForeclosureDetails = (props: IForeclosureDetails) => {
  const { foreclosureAmount, isLoading, containerClass } = props;

  if (isLoading)
    return (
      <div className="flex items-center justify-center mt-6">
        <CircularLoaderIcon size="md" />
      </div>
    );

  if (!foreclosureAmount) return null;

  return (
    <div className={`bg-[#F9F9F9] px-3 py-[6px] mt-3 rounded-md ${containerClass}`}>
      <ForeclosureItem
        title="Total foreclosure amount"
        titleColor="var(--navi-color-gray-c1)"
        amountColor="var(--navi-color-green-base)"
        amount={formatAmount(foreclosureAmount.totalAmount, false)}
        amountClass="font-medium"
      />
      <div className="h-[1px] mt-[6px] mb-[10px] bg-[var(--navi-color-gray-border)]" />

      <ForeclosureItem
        title="Principal"
        amount={formatAmount(foreclosureAmount.principal, false)}
      />
      <ForeclosureItem
        title="Total Interest"
        amount={formatAmount(foreclosureAmount.interest, false)}
        tooltip={
          <Tooltip placement="top">
            <TooltipContent className="px-2 pt-[6px] bg-[var(--grayscale-1)] z-[var(--z-index-overlay)] rounded-[4px] w-[240px]">
              <div className="flex items-center justify-between">
                <Typography color="var(--text-primary)" variant="h5">
                  Interest Due
                </Typography>
                <Typography color="var(--text-primary)" variant="h5">
                  {formatAmount(foreclosureAmount.interestDue, false)}
                </Typography>
              </div>

              <div className="flex items-center justify-between">
                <Typography color="var(--text-primary)" variant="h5">
                  Interest Accrued
                </Typography>
                <Typography color="var(--text-primary)" variant="h5">
                  {formatAmount(foreclosureAmount.interestAccrued, false)}
                </Typography>
              </div>

              <div className={`flex items-center justify-between ${styles.tooltipBorder}`}>
                <Typography color="var(--text-primary)" variant="h5">
                  Total Interest
                </Typography>
                <Typography color="var(--text-primary)" variant="h5">
                  {formatAmount(foreclosureAmount.interest, false)}
                </Typography>
              </div>
            </TooltipContent>{' '}
            <TooltipTrigger className="tooltipContent">
              <InfoIcon />
            </TooltipTrigger>
          </Tooltip>
        }
      />
      <ForeclosureItem
        title="Penalty Charges"
        amount={formatAmount(foreclosureAmount.penaltyCharges, false)}
        showCrossedAmount={(foreclosureAmount?.penaltyChargesPreWaiver as number) > 0}
        preAmount={formatAmount(foreclosureAmount?.penaltyChargesPreWaiver as number, false)}
      />
      {foreclosureAmount.closingInterest > 0 ? (
        <ForeclosureItem
          title="Closing Interest"
          amount={formatAmount(foreclosureAmount.closingInterest, false)}
        />
      ) : null}
      {foreclosureAmount.excessAvailable > 0 ? (
        <ForeclosureItem
          title="Excess Available"
          amount={'- ' + formatAmount(foreclosureAmount.excessAvailable, false)}
        />
      ) : null}
    </div>
  );
};

export default ForeclosureDetails;
